const config = require("../config.js");
const UTILS = require("./utils.js");
module.exports = function () {
  this.divs = [];
  var v13822;
  this.update = function (delta) {
    for (var v13823 = this.divs.length - 1; v13823 >= 0; --v13823) {
      v13822 = this.divs[v13823];
      if (v13822.delay > 0) {
        v13822.delay -= delta;
        if (v13822.delay <= 0) {
          v13822.style.display = "inline-block";
        }
      } else {
        if (v13822.scale > v13822.minScale) {
          v13822.scale -= v13822.scaleSpeed * delta;
          if (v13822.scale <= v13822.minScale) {
            v13822.scale = v13822.minScale;
          }
          v13822.style.fontSize = v13822.scale + "px";
        }
        if (v13822.scaleSpd) {
          v13822.startS += v13822.scaleSpd * delta;
          v13822.style.width = v13822.startS + "px";
          v13822.style.height = v13822.startS + "px";
        }
        v13822.life -= delta;
        if (v13822.life <= 0) {
          v13822.style.display = "none";
          var v13824 = v13822.callback;
          this.divs.splice(v13823, 1);
          if (v13824) {
            v13824();
          }
        }
        if (v13822.fade && v13822.life <= v13822.fade) {
          v13822.style.opacity = v13822.life / v13822.fade;
        }
        if (v13822.srcA && v13822.srcA.cnt && v13822.maxLife - v13822.life <= v13822.srcA.tim) {
          var v13825 = Math.floor(v13822.srcA.cnt * ((v13822.maxLife - v13822.life) / v13822.srcA.tim));
          v13822.src = UTILS.assetsUrl("/textures/" + (v13822.srcA.src + "_" + v13825) + ".png");
        }
      }
    }
  };
  this.animateText = function (p17636, p17637, p17638, p17639, p17640, p17641, p17642, p17643) {
    if (this.divs.indexOf(p17636) < 0) {
      this.divs.push(p17636);
    }
    p17636.delay = p17642;
    if (!p17642) {
      p17636.style.display = "inline-block";
    }
    p17636.style.fontSize = p17638 + "px";
    p17636.scale = p17638;
    p17636.minScale = p17639 ? p17638 * 0.4 : p17638;
    p17636.innerHTML = p17637;
    p17636.scaleSpeed = p17639;
    p17636.life = p17640;
    p17636.fade = p17641;
    p17636.style.opacity = 1;
    p17636.callback = p17643;
  };
  this.animateDiv = function (p17644, p17645, p17646, p17647, p17648, p17649) {
    if (this.divs.indexOf(p17644) < 0) {
      this.divs.push(p17644);
    }
    p17644.style.display = "block";
    p17644.life = p17645;
    p17644.maxLife = p17645;
    p17644.srcA = p17649;
    if (p17649) {
      p17644.src = UTILS.assetsUrl("/textures/" + p17649.src + "_0.png");
    }
    p17644.style.opacity = 1;
    p17644.fade = p17646;
    if (p17647) {
      p17644.style.width = p17647 + "px";
      p17644.style.height = p17647 + "px";
      p17644.startS = p17647;
      p17644.scaleSpd = p17648;
    }
  };
  this.reset = function () {
    for (var vLN02528 = 0; vLN02528 < this.divs.length; ++vLN02528) {
      this.divs[vLN02528].style.display = "none";
    }
    this.divs.length = 0;
  };
};